import { all } from "redux-saga/effects"

import passwordSaga from "./password/saga"

function* profileSaga() {
  yield all([passwordSaga()])
}

export default profileSaga
